import ActivityGroupService from '@/bundles/ActivityGroup/services/ActivityGroupService';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { http } from '@/bundles/Http/factory/HttpFactory';

function activityGroupServiceFactory() {
  return new ActivityGroupService({
    errorMapper: new ErrorMapper(),
    transport: http,
  });
}

export const activityGroupService = activityGroupServiceFactory();
